export const getProductCanBeBought = ({
  isNotForSale,
  pathname,
  isProductMenu
}: {
  isProductMenu: boolean;
  isNotForSale: boolean;
  pathname: string;
}): boolean => {
  const isMenuUrl = pathname.includes('/bar-menu/');
  return isMenuUrl ? !!isProductMenu : !isNotForSale;
};
